import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const slider = () => {
  if (document.getElementById("image-carousel")) {
    let splide = new Splide("#image-carousel", {
      type: "loop",
      autoWidth: true,
      autoScroll: {
        speed: 1,
      },
      arrows: false,
      pagination: false,
      easing: "linear",
    });

    splide.mount({ AutoScroll });
  }

  if (document.getElementById("testemonials-slider")) {
    let testemonials = new Splide("#testemonials-slider", {
      type: "loop",
      autoWidth: true,
      arrows: true,
      gap: "2.4rem",
      waitForTransition: true,
      focus: "center",
      classes: {
        arrows: "testemonials__slider-arrows",
      },
    });

    testemonials.mount();
  }
};

export default slider;
